import React from 'react';
import { NavLink, Outlet, useParams } from 'react-router-dom';

const TABS = [
  { to: 'overview',     label: 'Organisation' },
  { to: 'my-role',      label: 'Role'         },
  { to: 'hr-policies',  label: 'Documents'    },
  { to: 'org-chart',    label: 'Org Chart'    },
];

export default function MyOrganisationShell() {
  const { appId } = useParams();
  return (
    <div className="setup-page">
      <h1 className="page-title">My Organisation</h1>
      <div className="setup-tabs" role="tablist">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={`/apps/${appId}/my-organisation/${t.to}`}
            className={({ isActive }) => `setup-tab${isActive ? ' active' : ''}`}
            role="tab"
          >
            {t.label}
          </NavLink>
        ))}
      </div>
      <div className="setup-tab-body">
        <Outlet />
      </div>
    </div>
  );
}
